// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Case LowerCased, Added Comment Lines'
// Modified Date : 22-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { FIN_API_URL } from '../../const';

/***********  CREATE CASH TRANSACTION DETAILS START *************** */
export const cashTransactionCreate = (addData: any) => {
	const data = {
		createTranscationEntryToken: addData,
	};
	const url = `${FIN_API_URL}createTranscationEntry`;
	return makeApiCall(url, data);
};
/***********  CREATE CASH TRANSACTION DETAILS END *************** */

/*** GET CASH TRANSACTION LIST START ***/
export const cashTransactionListGet = (getData: any) => {
	const data = {
		getCompanyTranscationEntryListToken: getData,
	};
	const url = `${FIN_API_URL}getCompanyTransactions`;
	return makeApiCall(url, data);
};

/*** UPDATE CASH TRANSACTION DETAILS START ***/
export const cashTransactionUpdate = (updateData: any) => {
	const data = {
		updateCashTransactionToken: updateData,
	};
	const url = `${FIN_API_URL}updateTranscationEntry`;
	return makeApiCall(url, data);
};
/*** DELETE CASH TRANSACTION DETAILS START ***/
export const cashTransactionDelete = (deleteData: any) => {
	const data = {
		deleteCashTransactionToken: deleteData,
	};
	const url = `${FIN_API_URL}deleteTransaction`;
	return makeApiCall(url, data);
};

/*** GET COMPANY FINANCE ACCOUNT TYPE LIST START ***/
export const companyFinanceAccountTypeListGet = (requestData: any) => {
	const data = {
		getCompanyFinanceAccountTypeListToken: requestData,
	};
	const url = `${FIN_API_URL}getCompanyFinanceAccountTypeList`;
	return makeApiCall(url, data);
};
/*** GET COMPANY FINANCE ACCOUNT TYPE LIST END ***/

export const accountDayBookGet = (dayBookData: any) => {
	const data = {
		getExistAccountDayBookKeyToken: dayBookData,
	};
	const url = `${FIN_API_URL}getAccountDayBook`;
	return makeApiCall(url, data);
};

/*** GET VOUCHER COUNT BASED ON COMPANY START ***/
export const getVoucherCountBasedCompany = (requestData: any) => {
	const data = {
		getCompanyVoucherCountBasedOnCompanyToken: requestData,
	};
	const url = `${FIN_API_URL}getVoucherCountBasedOnCompany`;
	return makeApiCall(url, data);
};
/*** GET VOUCHER COUNT BASED ON COMPANY END ***/

/*** CHECK BRANCH EOD DONE START ***/
export const checkBranchEODDoneService = (requestData: any) => {
	const data = {
		getParticularBranchEODListToken: requestData,
	};
	const url = `${FIN_API_URL}checkBranchEODDone`;
	return makeApiCall(url, data);
};
/*** CHECK BRANCH EOD DONE END ***/

/*** GET PARTICULAR CASH TRANSACTION LIST START ***/
export const getParticularCashTransactionListService = (requestData: any) => {
	const data = {
		particulerBranchAccountToken: requestData,
	};
	const url = `${FIN_API_URL}getParticularBranchAccountList`;
	return makeApiCall(url, data);
};
/*** GET PARTICULAR CASH TRANSACTION LIST END ***/

// /***** UPDATE SELECTED TRANSACTION IS_APPROVE START *****/
export const cashTransactionApproveUpdate = (approveData: any) => {
	const data = {
		approvalUpdateCashTransactionToken: approveData,
	};
	const url = `${FIN_API_URL}updateSelectedTranscationIsApprove`;
	return makeApiCall(url, data);
};
// /***** UPDATE SELECTED TRANSACTION IS_APPROVE END *****/

/*** GET VALUES MODAL START ***/
export const getValuesModalService = (requestData: any) => {
	const data = {
		getModalValuesToken: requestData,
	};
	const url = `${FIN_API_URL}getValuesModal`;
	return makeApiCall(url, data);
};
/*** GET VALUES MODAL END ***/

/*** GET ACCOUNT DAY BOOK FOR ACCOUNT START ***/
export const getAccountDayBookForAccounts = (requestData: any) => {
	const data = {
		getExistAccountDayBookForAccountToken: requestData,
	};
	const url = `${FIN_API_URL}	`;
	return makeApiCall(url, data);
};
/*** GET ACCOUNT DAY BOOK FOR ACCOUNT END ***/
